<template>
  <div class="main-box">
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="业绩订单" name="order"></el-tab-pane>
      <el-tab-pane label="订单明细" name="detail"></el-tab-pane>
    </el-tabs>

    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item label="">
        <el-select v-model="search.status" placeholder="请选择结算类型" clearable>
          <el-option label="全部" :value="0"></el-option>
          <el-option v-for="item in statusList" :key="item.id" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入姓名/手机号/订单号" size="small" clearable>
          <el-button slot="append" class="iv-search" size="small" type="primary" @click="handleSearch">搜索</el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini">
      <el-table-column
          prop="member_id"
          label="用户"
          align="center"
          width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.user_id" class="member-box">
            <img :src="scope.row.avatar" />
            <div>
              <div>{{scope.row.name}}（{{scope.row.user_id}}）</div>
              <div>{{scope.row.mobile}}</div>
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="from_member_id"
          label="来源用户"
          align="center"
          width="300">
        <template slot-scope="scope">
          <div v-if="scope.row.from_user_id" class="member-box">
            <img :src="scope.row.from_member_avatar" />
            <div>
              <div>{{scope.row.from_member_name}}（{{scope.row.from_user_id}}）</div>
              <div>{{scope.row.from_member_mobile}}</div>
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="commission_type_str"
          label="类型"
          min-width="120">
      </el-table-column>
      <el-table-column
          prop="level"
          label="等级">
        <template slot-scope="scope">
          {{scope.row.level}}级
        </template>
      </el-table-column>
      <el-table-column
          prop="order_sn"
          label="订单号"
          min-width="150">
      </el-table-column>
      <el-table-column
          prop="amount"
          label="付款金额">
      </el-table-column>
      <el-table-column
          prop="commission"
          label="总业绩金额">
      </el-table-column>
      <el-table-column
          prop="pending_commission"
          label="待结算金额">
      </el-table-column>
      <el-table-column
          prop="settle_commission"
          label="已结算金额">
      </el-table-column>
      <el-table-column
          prop="refund_commission"
          label="已退款业绩">
      </el-table-column>
      <el-table-column
          prop="status_str"
          label="结算状态">
      </el-table-column>
      <el-table-column
          prop="create_time"
          label="添加时间"
          align="center"
          width="140">
      </el-table-column>
    </el-table>

    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
  </div>
</template>
<script>

export default {
  components: {},
  data() {
    return {
      info: false,
      activeTab: 'order',
      source_domain: this.config.SOURCE_DOMAIN,
      statusList: [
        { id: 1, title: '待结算' },
        { id: 2, title: '结算中' },
        { id: 3, title: '已结算' },
        { id: 4, title: '已退款' },
      ],
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        status: '',
        member_id: ''
      },
      tableData: []
    };
  },
  created() {
    if (this.$route.query.member_id) {
      this.search.member_id = parseInt(this.$route.query.member_id)
    }
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        member_id: that.search.member_id,
        status: that.search.status,
      }
      this.$api.member.memberCommissionOrder(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    handleTabClick() {
      if(this.activeTab === 'detail') {
        this.$router.push({ name: 'member_commission_order_detail', query: this.$route.query })
      }
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
